import { Injectable } from '@angular/core';
import { Leaderboard } from 'src/app/libs/proto/commUnity_pb';
import { BinaryWriter } from 'google-protobuf';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardConversionService {
  constructor(){}

  ToStorage(req: Leaderboard) {
    const w = new BinaryWriter();
    Leaderboard.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (leaderboard: Leaderboard, errorConvert: any) => void) {
    try {
      callback( Leaderboard.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(leaderboard: Leaderboard[]) {
    const rets = new Array<Uint8Array | number[]>();

    leaderboard.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (leaderboard: Leaderboard[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Leaderboard>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Leaderboard.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }



}
